module.exports = __webpack_public_path__ + "static/make-video-slide2-f7094a06b8e5da408793ae63ee46cd4c.png";